import { useLocation, Location } from 'react-router-dom';
import { ReactRouterLocationState } from '../appTypings';

/**
 * Type wrapper to ensure proper type of the location state-prop.
 * Use this instead of the hook exported by 'react-router-dom'
 */
export function useLocationWithState(): Location<ReactRouterLocationState> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return useLocation();
}
